/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcHeartFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M3.446 3.864C6.012 1.574 9.86 1.935 12 4.582c2.139-2.647 5.987-3.008 8.553-.718 2.656 2.371 2.81 6.58.34 9.152l-7.87 8.195a1.413 1.413 0 0 1-2.047 0l-7.87-8.195c-2.47-2.572-2.316-6.781.34-9.152" />
    </svg>
  );
}
export default IcHeartFill;
